// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"26":"organization","245":"notfound","378":"user","535":"login","543":"equipment"}[chunkId] || chunkId) + "-legacy." + {"26":"f1edaa9c","245":"ddb99887","378":"0463b168","422":"9534ce33","535":"fb2ebad7","543":"bf41a340"}[chunkId] + ".js";
};